import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Dropdown, DropdownButton, FormGroup, FormControl, FormLabel, InputGroup } from 'react-bootstrap';

import PropTypes from 'prop-types';

import { Dots } from 'react-activity';
import 'react-activity/dist/react-activity.css';

import { faMobileAlt, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import CurrencyCardIcon from '../utils/currency-card-icon.js';


class QuoteCreateForm extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;
		
		let title = '';
		let description = '';
		let amount = 0;
		let currency = {symbol: ''};
		let currencies= [];
		let signingkey = null;
		let currentcard = null;
		let balance = '';
		
		this.state = {
			title,
			description,
			amount,
			currency,
			currencies,
			signingkey,
			currentcard,
			balance,
			message_text: '',
			processinginfo: 'processing submission',
			processing: false
	};
	}

	
	// post render commit phase
	componentDidUpdate(prevProps, prevState) {
		//console.log('QuoteCreateForm.componentDidUpdate called');
		
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;
		
		// limit the size of description to 1024
		if (this.state.description != prevState.description) {
			if (this.state.description.length > 1024) {
				let description = this.state.description.slice(0,1024);

				this.setState({description});
			}
		}

		// entered a private key
		if (this.state.signingkey != prevState.signingkey) {
			const {currency} = this.state;

			if ( (currency) && (currency.uuid)) {
				let currentcard = null;
				let balance = '';
				
				let currencyuuid = currency.uuid;

				this.app.createCurrencyCard(currencyuuid, this.state.signingkey, {maincard: true})
				.then(card => {
					currentcard = card;

					return mvcmyquote.getCurrencyPosition(rootsessionuuid, walletuuid, currencyuuid)
				})
				.then((pos) => {
					return mvcmyquote.formatCurrencyAmount(rootsessionuuid, currencyuuid, pos);
				})
				.then((balance) => {
					this.setState({currentcard, balance});
				})
				.catch(err => {
					this.setState({currentcard, balance})
				});
			}
		}

		// selected a currency
		if (this.state.currency && this.state.currency.uuid && (this.state.currency.uuid != (prevState.currency ? prevState.currency.uuid : null))) {
			// we reset the current card
			let currentcard = null;
			let balance = '';

			const currency = this.state.currency;
			let currencyuuid = currency.uuid;

			this.app.openCurrencyCard(currencyuuid)
			.then(card => {
				if (!card)
					throw 'no current card';

				currentcard = card;

				return mvcmyquote.getCurrencyPosition(rootsessionuuid, walletuuid, currencyuuid);
			})
			.then((pos) => {
				return mvcmyquote.formatCurrencyAmount(rootsessionuuid, currencyuuid, pos);
			})
			.then((balance) => {
				this.setState({currentcard, balance});
			})			
			.catch(err => {
				this.setState({currentcard, balance})
			});

		}
	}

	componentDidMount() {
		console.log('QuoteCreateForm.componentDidMount called');
		
		let mvcmyquote = this.getMvcMyQuoteObject();
		
		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		// list of currencies
		this.mvcmyquote.getCurrencies(rootsessionuuid, walletuuid)
		.then((currencies) => {
			this.setState({currencies});
		})
		.catch(err => {
			console.log('error in QuoteCreateForm.componentDidMount ' + err);
		});


		// message translated in user's language
		let message_text = mvcmyquote.t(
		'When you press the button \'Create Quote\', a url will be generated that you will \
		be able to publish on the web or send via email to your clients. \
		If you haven\'t yet provided your private key for the corresponding currency, \
		you will be asked to enter it at the next step so that your quote is signed. \
		Your private key will be crypted and stored on your device, it will not leave \
		your device at any time and will not be shared with anyone. \
		Your quote will then be registered and be accessible to anyone clicking on \
		the link that has been generated. \
		Your clients will then be able to place their order and will sign them with their own \
		private key.');

		this.setState({message_text});

		this.checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err);});
	}

	async checkNavigationState() {
		let app_nav_state = this.app.getNavigationState();
		let app_nav_target = app_nav_state.target;

 		// check wallet is unlocked
		let unlocked = await this.app.checkWalletUnlocked()
		.catch(err => {
		});

		if (!unlocked) {
			let params = (app_nav_target ? app_nav_target.params : null);
			this.app.gotoRoute('login', params);
			return;
		}
		else {
			 // check it is not the device wallet, because we need a safer wallet
			 let isdevicewallet = await this.app.isDeviceWallet();
			 
			 if (isdevicewallet) {
			 	await this.app.resetWallet();
				 
				let params = (app_nav_target ? app_nav_target.params : null);
				this.app.gotoRoute('login', params);
				return;
			  }
		}

		if (app_nav_target && (app_nav_target.route == 'quote') && (app_nav_target.reached == false)) {
		}

	 }

	
	// user actions
	
	async onSubmit() {
		console.log('onSubmit pressed!');
		
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;
		
		let wallet;
		let carduuid;
		let card;
		
		let { title, description, amount, currency, currencies, currentcard, signingkey } = this.state;

		this.setState({processing: true});

		try {

			if (!title || (title.length == 0)) {
				this.app.alert('You need to enter a title');
				this.setState({processing: false});
				return;
			}
	
			if (!currency || !currency.uuid) {
				this.app.alert('You need to specify a valid currency');
				this.setState({processing: false});
				return;
			}
	
			// get wallet details
			wallet = await mvcmodule.getWalletInfo(rootsessionuuid, walletuuid);
	
			if (currentcard) {
				card = currentcard;
				carduuid = card.uuid;
			}
			else {
				if (signingkey) {
					let currencyuuid = currency.uuid;
		
					card = await this.app.createCurrencyCard(currencyuuid, signingkey, {maincard: true})
					.catch(err => {
						console.log('error in QuoteCreateForm.onSubmit: ' + err);
					});
	
					if (!card) {
						this.app.alert('Could not create card from private key');
						this.setState({processing: false});
						return;
					}
				}
				else {
					this.app.alert('You need to provide your private key for ' + currency.name + ' in order to sign your quote');
					this.setState({processing: false});
					return;
				}
		
			}
	
			// we get the pretrade card to save a transaction
			let pretradecard = await mvcmyquote.getPretradeCard(rootsessionuuid, walletuuid, carduuid, currency.uuid)
			.catch(err => {
				console.log('error in QuoteCreateForm.onSubmit: ' + err);
			});
	
			if (!pretradecard) {
				this.app.alert('Could not get a card to register the quote');
				this.setState({processing: false});
				return;
			}
	
			// we top-up pretrade card to be sure being able to send a transaction
			const topupinfo = await mvcmodule.topUpCard(rootsessionuuid, walletuuid, pretradecard.uuid)		
			.catch(err => {
				console.log('error in QuoteCreateForm.onSubmit: ' + err);
			});
	
			if ((!topupinfo) || (!topupinfo.top) ) {
				this.app.alert('Could not top up account to register quote. Wait a few seconds and try again.');
				this.setState({processing: false});
				return;
			}
			else {
				let transactioninfo = await mvcmyquote.getSchemeTransactionInfo(rootsessionuuid, pretradecard.schemeuuid);

				if (topupinfo.balance <= (transactioninfo ? transactioninfo.credits_threshold :  1)) {
					this.app.alert('Account has not been topped-up yet. Wait a few seconds and try again.');
					this.setState({processing: false});
					return;
				}
			} 
	
			// send transaction
			let owner_address = pretradecard.address;
			let owner_rsa_publickey = pretradecard.publickeys['rsa_public_key'];
	
			let quote = {type: 'quote', title, description, amount, currency: currency.symbol, currencyuuid: currency.uuid, owner: owner_address, owner_rsa_publickey};
			let assignto = owner_address;
	
			let txhash = await mvcmyquote.registerTransaction(rootsessionuuid, walletuuid, pretradecard.uuid, quote, assignto)
			.catch(err => {
				console.log('error in QuoteCreateForm.onSubmit: ' + err);
			});
	
			if (!txhash) {
				this.app.alert('Could not register the quote');
				this.setState({processing: false});
				return;
			}
	
	
			// get share link
			var quoteurl = await this.app.getShareLink(txhash, currency.uuid);
	
			//this.app.alert('Send url ' + quoteurl);
	
			// go to list view (to let time for the blockchain to commit the transactions)
			let params = {action: 'view', txhash, currencyuuid: currency.uuid};
	
			await this.app.gotoRoute('quotes', params);
	
			this.setState({processing: false});
	
			return true;
		}
		catch(e) {
			console.log('exception in onSubmit: ' + e);
			this.setState({processing: false});
		}

	}

	async onChangeCurrency(e) {
		var cur = e.target.value;

		var {currencies} = this.state;
		var currency;

		for (var i = 0; i < currencies.length; i++) {
			if (cur === currencies[i].symbol) {
				currency = currencies[i];
				break;
			}
		}

		if (currency) {
			this.setState({currency});
		}
	}

	async onSelectCurrency(uuid) {
		var {currencies} = this.state;
		var currency;

		for (var i = 0; i < currencies.length; i++) {
			if (uuid === currencies[i].uuid) {
				currency = currencies[i];
				break;
			}
		}

		if (currency)
		this.setState({currency});
	}

	async onShowCurrencyCard() {
		let currency = this.state.currency;
		let params = {currencyuuid: currency.uuid};
		this.app.gotoRoute('currencycard', params);
	}

	
	// rendering
	renderQuoteCreateForm() {
		let { title, description, amount, currencies, currency, currentcard, signingkey, balance, message_text } = this.state;
		
		return (
			<div className="Form">
			  <div>
				<FormGroup controlId="title">
				  <FormLabel>Quote Title</FormLabel>
				  <FormControl
					autoFocus
					type="text"
					value={title}
					onChange={e => this.setState({title: e.target.value})}
				  />
				</FormGroup>

				<FormGroup controlId="description">
				  <FormLabel>Description</FormLabel>
				  <FormControl 
					as="textarea" 
					rows="5" 
					autoFocus
					type="text"
					value={description}
					onChange={e => this.setState({description: e.target.value})}
				  />
				</FormGroup>
				
				<FormGroup className="Proposal" controlId="proposal">
				<span className="ProposalCol">
				<FormLabel>Amount</FormLabel>
				<FormControl 
					autoFocus
					type="text"
					value={amount}
					onChange={e => this.setState({amount: e.target.value})}
				  />
				</span>
				<span className="ProposalCol">
				<FormLabel>Currency</FormLabel>
				<InputGroup>
					<FormControl 
						autoFocus
						type="text"
						value={currency.symbol}
						onChange={e => this.onChangeCurrency(e)}
					/>
					<DropdownButton
						id="input-dropdown-addon"
						title="Cur."
						onSelect={e => this.onSelectCurrency(e)}
					>
						{currencies.map((item, index) => (
							<Dropdown.Item key={item.uuid} eventKey={item.uuid} value={item.uuid}>{item.symbol}</Dropdown.Item>
						))}
					</DropdownButton>
				</InputGroup>
				 </span>
				</FormGroup>

				{(currentcard ?
					<FormGroup className="CurrencyCard" controlId="address">
					<span className="CardIconCol">
						<CurrencyCardIcon
							app={this.app}
							currency={currency}
							card={currentcard}
						/>
					</span>
					<span className="CardBalanceCol">
						<FormLabel>Balance</FormLabel>
						<FormControl
							className="CardBalanceCol"
							disabled
							autoFocus
							type="text"
							value={balance}
						/>
					</span>
					</FormGroup> :
					<FormGroup controlId="signingkey">
						<FormLabel>Private key {(currency && currency.name ? 'for ' + currency.name : '')}</FormLabel>
						<FormControl
						autoFocus
						type="text"
						value={(signingkey ? signingkey : '')}
						onChange={e => this.setState({signingkey: e.target.value})}
						/>
					</FormGroup>
				)}
				
				<Button 
				disabled={(currentcard ? false : true)}
				onClick={this.onSubmit.bind(this)} 
				type="submit">
				  Create Quote
				</Button>

				<div className="TextBox">
				  {message_text}
			  	</div>

			  </div>
			</div>
		  );
	}

	renderItem(item){
		let type = item.type;
		let label = item.label;

		return (
			<div>
				<span>{(type == 0 ? <FontAwesomeIcon icon={faMobileAlt} /> : <FontAwesomeIcon icon={faGlobe} />)}</span>
				<span>{label}</span>
			</div>
		);
	}
	

	render() {
		let {processing} = this.state; 
		
		if (processing === true) {
			return (
				<div className="Splash">
					<div>{this.state.processinginfo}</div>
					<Dots />
				</div>
			);
		}
		
		return (
			<div className="Container">
				<div className="Title">Create Quote</div>
				{ this.renderQuoteCreateForm()}
			</div>
		  );
	}
	
}


// propTypes validation
QuoteCreateForm.propTypes = {
	app: PropTypes.object.isRequired,
	rootsessionuuid: PropTypes.string,
	currentwalletuuid: PropTypes.string,
};

//redux
const mapStateToProps = (state) => {
	return {
		rootsessionuuid: state.session.sessionuuid,
		pending: state.login.pending,
		success: state.login.success,
		lasterror: state.login.error,
		currentwalletuuid: state.wallets.walletuuid,
		currentcarduuid: state.cards.carduuid,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
	};
}


export {QuoteCreateForm};
export default connect(mapStateToProps, mapDispatchToProps)(QuoteCreateForm);

